import { CoreIcon } from '../core-icon';
import appLineappSVG from '../../assets/logos/app-lineapp.svg';
import type { IconProps } from '../core-icon';

export const AppLineappIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={appLineappSVG} {...props} />;
};
